import { Component, OnInit, OnDestroy } from '@angular/core';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form/components/base-ctrl-value-accessor-form.component';
import { DES } from '@atmi/core/models';

@Component({
  selector: 'app-des-form',
  templateUrl: './des-form.component.html',
  styleUrls: ['./des-form.component.scss'],
})
export class DesFormComponent extends BaseCtrlValueAccessorFormComponent<DES> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
